(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,LAYERS,HOOD_COLORS,RIDGELINES,SUSPENSIONS,CONTINUOUS_LOOPS,DELTAS,STUFF_SACKS,REQUIRED_DELTA_FIELDS}=window.SLDEstimatorData.products["voyageur"];
const RIDGELINE_SHARED=window.SLDEstimatorData.shared.hammocks.ridgelines;
const CONTROLS=window.SLDEstimatorData.productControls.voyageur;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric/Color',
    'Length * (required)': 'Length',
    'Layers * (required)': 'Layers',
    'Hood Color * (required)': 'Hood Color',
    'Ridgeline * (required)': 'Ridgeline',
    'Suspension * (required)': 'Suspension',
    'Continuous Loops * (required)': 'Continuous Loops',
    'Knee & Shoulder Tie Outs * (required)': 'Knee & Shoulder Tie Outs',
    'Under Quilt Hooks * (required)': 'Under Quilt Hooks',
    'Peak Shelf * (required)': 'Peak Shelf',
    'Ridgeline Gear Pouch * (required)': 'Ridgeline Gear Pouch',
    'Stuff Sack Options * (required)': 'Stuff Sack Options',
    'Zippered Shoulder Pouch * (required)': 'Zippered Shoulder Pouch'
  });

  

  
  

  

  

  

  

  

  

  const DEFAULTS = Object.freeze({
    Layers: 'Single',
    Ridgeline: "None (I will use my own)",
    Suspension: "None (I will use my own)",
    'Continuous Loops': 'No',
    'Knee & Shoulder Tie Outs': "No",
    'Under Quilt Hooks': 'No',
    'Peak Shelf': "No",
    'Ridgeline Gear Pouch': 'No',
    'Stuff Sack Options': 'Standard Stuff Sack',
    'Zippered Shoulder Pouch': 'No'
  });

  

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function deltaFor(field, value) {
    return own(DELTAS, field) && own(DELTAS[field], value) ? DELTAS[field][value] : 0;
  }

  function hoodWeight(fabric, hoodColor) {
    if (!own(HOOD_COLORS, hoodColor)) return undefined;
    if (hoodColor !== 'Matching') return HOOD_COLORS[hoodColor];
    return fabric.hood === undefined ? fabric.density * CONTROLS.hoodFallbackArea : fabric.hood;
  }

  function ridgelineWeight(kind, length) {
    if (kind === 'none') return 0;
    if (kind === 'adjustable') return RIDGELINE_SHARED.adjustableByLength[length];
    if (kind === 'fixed') return RIDGELINE_SHARED.fixed.baseWeight + (length - RIDGELINE_SHARED.fixed.baseLengthFeet) * RIDGELINE_SHARED.fixed.perFootAdjustment;
    return undefined;
  }

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent);
      if (!own(FIELD_LABELS, domLabel)) continue;
      const field = FIELD_LABELS[domLabel];
      const value = clean(element.value);
      selected[field] = value || (own(DEFAULTS, field) ? DEFAULTS[field] : '');
    }
    return selected;
  }

  function estimate(choice) {
    const fabric = FABRICS[choice['Fabric/Color']];
    const length = LENGTHS[choice.Length];
    const layerCount = LAYERS[choice.Layers];
    const hood = fabric && hoodWeight(fabric, choice['Hood Color']);
    const ridgelineKind = RIDGELINES[choice.Ridgeline];
    const suspension = SUSPENSIONS[choice.Suspension];
    const loops = CONTINUOUS_LOOPS[choice['Continuous Loops']];
    const stuffSackUpgrade = STUFF_SACKS[choice['Stuff Sack Options']];
    const deltasValid = REQUIRED_DELTA_FIELDS.every(
      (field) => own(DELTAS[field], choice[field])
    );

    if (!fabric || !length || !layerCount || hood === undefined ||
        ridgelineKind === undefined || !suspension || loops === undefined ||
        stuffSackUpgrade === undefined || !deltasValid) return null;

    const body = ((length * 12 + 8) * fabric.width / 1296) * fabric.density * layerCount;
    let hammock = body + hood + ridgelineWeight(ridgelineKind, length);
    if (!suspension.includesLoops) hammock += loops;
    for (const field of REQUIRED_DELTA_FIELDS) hammock += deltaFor(field, choice[field]);

    const withSuspension = hammock + suspension.weight;
    const packed = withSuspension + CONTROLS.mainSack + suspension.sack + stuffSackUpgrade;
    return { body, hood, hammock, withSuspension, packed };
  }

  function start() {
    const root = document.querySelector('[data-sld-voyageur-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const choice = selections(scope);
      const result = estimate(choice);
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (choice['Fabric/Color'] === 'Custom (Please Contact Me First)') {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Custom fabrics require a manual weight estimate. Please contact me before ordering.';
        return;
      }

      if (!result) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the hammock fabric, length, and hood color above to see estimated weights.';
        return;
      }

      const set = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value.toFixed(1) + ' oz';
      };
      set('[data-sld-weight-hammock]', result.hammock);
      set('[data-sld-weight-suspension]', result.withSuspension);
      set('[data-sld-weight-packed]', result.packed);
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { deltaFor, estimate, hoodWeight, ridgelineWeight, selections, start };
});
